<dx-box
    #workflowApprovedStepEditor
    *ngIf="!!approvedEditor"
    width="100%"
    height="100%"
    direction="col"
    class="workflow-accountant-box-container"
>
    <dxi-item baseSize="auto">
        <div *dxTemplate>
            <dx-box width="100%" height="100%" direction="row">
                <dxi-item [ratio]="1">
                    <div *dxTemplate>
                        <app-workflow-status-breadcrumb [breadCrumbs]="breadCrumbs"></app-workflow-status-breadcrumb>
                    </div>
                </dxi-item>
                <dxi-item baseSize="auto">
                    <div *dxTemplate>
                        <div class="setting-button-container">
                            <div class="icon-button-content">
                                <dx-button
                                    id="workflow-setting-button"
                                    class="workflow-setting-button-content cc-dummy-button"
                                    location="after"
                                    hint="Settings"
                                    type="default"
                                    [tabIndex]="-1"
                                >
                                    <div *dxTemplate="let data of 'content'">
                                        <div>
                                            <i title="Click to view settings" [ngClass]="iconSetting"></i>
                                        </div>
                                        <dx-context-menu
                                            target="#workflow-setting-button"
                                            showEvent="dxclick"
                                            [position]="{ my: 'top center', at: 'bottom center' }"
                                            [items]="settingsMenu"
                                        ></dx-context-menu>
                                    </div>
                                </dx-button>
                            </div>
                        </div>
                    </div>
                </dxi-item>
            </dx-box>
        </div>
    </dxi-item>
    <dxi-item [visible]="!!workflowId" baseSize="auto">
        <div *dxTemplate>
            <app-workflow-job-details
                *ngIf="!!workflowId"
                [workflowId]="workflowId"
                [communityId]="communityId"
                [hasNotes]="workflowEditor?.hasNotes"
                [hasBoardNotes]="approvedEditor?.hasBoardNotes"
                [hasVendorNotes]="approvedEditor?.hasVendorNotes"
                [vendorInstruction]="approvedEditor?.vendorInstruction"
                [hasBoardApproval]="true"
                [boardApprovalEnabled]="false"
                [hasWorkOrders]="true"
                [hasContracts]="true"
                [payee]="approvedEditor?.payee"
                [payeeCode]="workflowEditor?.payeeCode"
                [payeeType]="workflowEditor?.payeeType"
                [managementCompanyVendorId]="approvedEditor?.managementCompanyVendorId"
                [vendorAccountNumber]="approvedEditor?.vendorAccountNumber"
                [pdfSource]="pdfSource"
                [closeAllChildPopup]="closeAllChildPopup"
                (onForceRefresh)="onForceRefresh($event)"
                (onWorkOrderClick)="onWorkOrderClick()"
                (onContractsClick)="onContractsClick()"
            ></app-workflow-job-details>
        </div>
    </dxi-item>
    <dxi-item baseSize="auto">
        <div *dxTemplate>
            <app-workflow-invoice-header-editor
                #invoiceHeaderDetailEditor
                [workflowEditor]="workflowEditor"
                [allowEditInvoiceHeaderDetails]="approvedEditor?.allowEditInvoiceHeaderDetails"
                [managementCompanyId]="approvedEditor?.managementCompanyId"
                [vendorAccountNumber]="approvedEditor?.vendorAccountNumber"
                [payee]="approvedEditor?.payee"
                [bankBalance]="bankBalance"
                [bankAccounts]="approvedEditor?.bankAccounts"
                [matchEntityRequiredDimensions]="approvedEditor?.matchEntityRequiredDimensions"
                [boardApprovalEnabled]="false"
                [closeAllChildPopup]="closeAllChildPopup"
                [closedBookPeriod]="approvedEditor?.closedBookPeriod"
                [workflowStep]="workflowStep"
                (onBankAccountChange)="onBankAccountChange($event)"
                (onUpdateDescription)="onDescriptionUpdate($event)"
                (onEFTValueChanged)="onEFTValueChanged($event)"
            ></app-workflow-invoice-header-editor>
        </div>
    </dxi-item>
    <dxi-item [ratio]="1">
        <div *dxTemplate>
            <app-workflow-step-line-item-editor
                #workflowLineItemEditor
                [lineItems]="workflowEditor?.items"
                [matchEntityRequiredDimensions]="approvedEditor?.matchEntityRequiredDimensions"
                [glAccountsBudgetInfo]="approvedEditor?.glAccounts"
                [dimensionSource]="dimensionSource"
                [managementCompanyId]="approvedEditor?.managementCompanyId"
                [communityId]="workflowEditor?.communityId"
                [invoiceAmount]="workflowEditor?.amount"
                [entityUsesSubCategory]="approvedEditor?.entityUsesSubCategory"
                [selectedBankAccount]="selectedBankAccount"
                [targetCommunityList]="approvedEditor?.targetCommunityList"
                [description]="description"
                [payeeCode]="workflowEditor?.payeeCode"
                [vendorAccountId]="workflowEditor?.vendorAccountId"
                [workflowId]="workflowId"
                [workflowStatus]="workflowEditor?.status"
                [allowEditInvoiceHeaderDetails]="approvedEditor?.allowEditInvoiceHeaderDetails"
            ></app-workflow-step-line-item-editor>
        </div>
    </dxi-item>
    <dxi-item baseSize="auto">
        <div *dxTemplate>
            <div class="full-width top-padding bottom-padding">
                <dx-toolbar width="100%">
                    <dxi-item location="after" [visible]="approvedEditor?.allowDelete">
                        <div *dxTemplate>
                            <dx-button
                                type="danger"
                                text="Delete Bill"
                                [icon]="iconDelete"
                                (onClick)="onDeleteClick()"
                            ></dx-button>
                        </div>
                    </dxi-item>

                    <dxi-item location="after" [visible]="approvedEditor?.allowReclassifyBill">
                        <div *dxTemplate>
                            <dx-button
                                type="default"
                                text="Reclassify Bill"
                                [icon]="iconRandom"
                                (onClick)="onApprovedReclassifyClick()"
                            ></dx-button>
                        </div>
                    </dxi-item>
                    <dxi-item location="after" [visible]="approvedEditor?.allowUpdateBill">
                        <div *dxTemplate>
                            <dx-button
                                type="default"
                                text="Update Bill"
                                [icon]="iconCheck"
                                (onClick)="onApprovedUpdateClick()"
                            ></dx-button>
                        </div>
                    </dxi-item>
                    <dxi-item location="after" [visible]="approvedEditor?.allowReverse">
                        <div *dxTemplate>
                            <dx-button
                                type="default"
                                text="Reverse"
                                [icon]="iconRandom"
                                (onClick)="onReverseClick()"
                            ></dx-button>
                        </div>
                    </dxi-item>
                    <dxi-item location="after">
                        <div *dxTemplate>
                            <dx-button
                                type="default"
                                [icon]="iconClose"
                                text="Exit"
                                (click)="onApprovedStepWorkflowClose()"
                            ></dx-button>
                        </div>
                    </dxi-item>
                </dx-toolbar>
            </div>
        </div>
    </dxi-item>
    <dxi-item baseSize="auto" [visible]="approvedEditor?.communityTerminated">
        <div *dxTemplate>
            <span class="cc-text-required cc-text-bold">
                This is a terminated community. Do you want to DENY this to AAP?
            </span>
        </div>
    </dxi-item>
</dx-box>

<app-workflow-step-reverse-or-delete
    *ngIf="showBillAction"
    [action]="selectedBillAction"
    (onDeniedReturnToCAM)="onDenyReturnToCAM()"
    (onDeniedSendToAAP)="onDenyReturnToAAP()"
    (onCompleteWorkflow)="onDeniedCompleteWorkflow()"
    (onClose)="onDenyEditorClose()"
></app-workflow-step-reverse-or-delete>

<app-workflow-workorder-selector
    *ngIf="showWorkOrder"
    step="approved"
    [workflowId]="workflowId"
    [communityId]="communityId"
    [vendorCode]="workflowEditor?.payeeCode"
    [workOrders]="approvedEditor?.linkedWorkOrderIds"
    [vendorId]="approvedEditor?.managementCompanyVendorId"
    (onClose)="onWorkOrderSelectorClose()"
></app-workflow-workorder-selector>

<!-- Contracts -->
<app-manage-contracts
    *ngIf="showContracts"
    [vendorName]="approvedEditor?.payee"
    [vendorCode]="workflowEditor?.payeeCode"
    [contextId]="workflowEditor?.communityId"
    [communityId]="workflowEditor?.communityId"
    [workflowId]="workflowEditor?.workflowId"
    (onClose)="showContracts = false"
    (onSaveWorkflowVendorContractClick)="onSaveWorkflowVendorContractClick($event)"
></app-manage-contracts>

<cc-message-box #workflowStepMessageBox></cc-message-box>

<dx-load-panel
    *ngIf="loadingVisible"
    [position]="{ of: '#workflowApprovedStepEditor' }"
    [visible]="loadingVisible"
    [showIndicator]="true"
    [showPane]="true"
    [shading]="true"
    [closeOnOutsideClick]="false"
></dx-load-panel>
